import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Moon, ShieldCheck, Sun } from 'lucide-react';
import { Button } from './Button';
import { usePlatform } from '../contexts/PlatformContext';
import { PACK_DAYS, formatAED, pillCountLabel, sachetPillCount } from '../utils/pack';
export function PackSummary() {
  const {
    packPills,
    packPrice
  } = usePlatform();
  const navigate = useNavigate();
  const empty = packPills.length === 0;
  const morningCount = sachetPillCount(packPills, 'Morning');
  const eveningCount = sachetPillCount(packPills, 'Evening');
  return <aside className="rounded-2xl border border-[#9b8cf0]/40 bg-[#9b8cf0]/[0.05] p-6 lg:sticky lg:top-24" data-id="element-82" data-mp="bjlajqcdqmba">
      <p className="font-mono text-xs uppercase tracking-widest text-[#c4baff]" data-id="element-83" data-mp="fk41zjad1qcy">Your 1-month pack</p>
      <p className="mt-3 text-4xl font-medium tracking-tight" data-id="element-84" data-mp="2w918r6dxhday">
        {formatAED(packPrice)}
        <span className="ml-1 text-sm font-normal text-muted-foreground" data-id="element-85" data-mp="30be3kzr4zqsy">/ mo</span>
      </p>
      <p className="mt-1 text-sm text-muted-foreground" data-id="element-86" data-mp="142k937ntykm">
        {packPills.length} {packPills.length === 1 ? 'supplement' : 'supplements'} · {morningCount + eveningCount} pills a day
      </p>

      <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-87" data-mp="a50tq10vayal">
        {[{
        label: 'Morning sachet',
        icon: Sun,
        count: morningCount
      }, {
        label: 'Evening sachet',
        icon: Moon,
        count: eveningCount
      }].map(s => <div key={s.label} className="rounded-xl border border-white/10 bg-[#0f1017]/60 p-3" data-id="element-88" data-mp="k25fw0upqtre">
            <p className="flex items-center gap-1.5 text-[11px] text-muted-foreground" data-id="element-89" data-mp="f3bxpv4heekw">
              <s.icon className="size-3" data-id="element-90" data-mp="ttjco0va5fgu" /> {s.label}
            </p>
            <p className="mt-1 text-lg font-medium" data-id="element-91" data-mp="ou6lx51afo8z">
              {s.count} <span className="text-xs font-normal text-muted-foreground" data-id="element-92" data-mp="ouyjumicxy2f">{s.count === 1 ? 'pill' : 'pills'}</span>
            </p>
          </div>)}
      </div>
      <p className="mt-2 text-[11px] text-muted-foreground" data-id="element-93" data-mp="xvmpotxlks48">
        × {PACK_DAYS} days = {(morningCount + eveningCount) * PACK_DAYS} pills in your pack
      </p>

      <ul className="mt-5 space-y-2.5 border-t border-white/10 pt-5" data-id="element-94" data-mp="gjlqe47gq8f">
        {empty && <li className="text-sm text-muted-foreground" data-id="element-95" data-mp="efky51ls7cd">Add at least one supplement to continue.</li>}
        {packPills.map(p => <li key={p.id} className="flex items-start gap-2.5 text-sm" data-id="element-96" data-mp="99de9d8nxm48">
            <span className="mt-1.5 size-2 shrink-0 rounded-full" style={{
          backgroundColor: p.color
        }} aria-hidden="true" data-id="element-97" data-mp="9aojlhhrb1xg" />
            <span className="flex-1" data-id="element-98" data-mp="j6rm4ogit2kx">
              <span className="block" data-id="element-99" data-mp="j5qaahrokc25">{p.name}</span>
              <span className="font-mono text-[11px] text-muted-foreground" data-id="element-100" data-mp="o6dw8p11y2pi">{p.dose} · {pillCountLabel(p)}</span>
            </span>
            <span className="font-mono text-[11px] text-muted-foreground" data-id="element-101" data-mp="s6oeb024cjkq">{p.timing === 'Morning' ? 'AM' : 'PM'}</span>
          </li>)}
      </ul>

      <p className="mt-6 flex gap-2 text-xs text-muted-foreground" data-id="element-102" data-mp="2tz2sbo1jl3vv">
        <ShieldCheck className="size-4 shrink-0 text-[#9b8cf0]" data-id="element-103" data-mp="2tzcjvg28jj3o" />
        A family-medicine doctor verifies every selection before it's packed.
      </p>

      <Button size="lg" className="mt-6 w-full bg-[#9b8cf0] text-[#0f1017] hover:bg-[#b0a4f5]" disabled={empty} onClick={() => navigate('/review')} data-id="element-104" data-mp="2hobg117gcuj7">
        Review pack <ArrowRight className="size-4" data-id="element-105" data-mp="28ooor88ft53v" />
      </Button>
    </aside>;
}